export default __webpack_public_path__ + "static/media/fastFood08.a083924d.png";